import { Icon, Menu, MenuButton, MenuList, useDisclosure } from '@chakra-ui/react';
import { ReactNode, useRef } from 'react';
import { MdOutlineMoreHoriz } from 'react-icons/md';

type TProps = {
    children: ReactNode;
};

export default function ActionCell({ children }: TProps) {
    const { isOpen: isOpen1, onOpen: onOpen1, onClose: onClose1 } = useDisclosure();
    const itemRef = useRef();

    return (
        <Menu isOpen={isOpen1} onClose={onClose1} initialFocusRef={itemRef}>
            <MenuButton
                alignItems="center"
                justifyContent="center"
                color="gray.900"
                _hover={{ bg: 'gray.50' }}
                _active={{ bg: 'gray.50' }}
                w="40px"
                h="40px"
                lineHeight="100%"
                onClick={onOpen1}
                borderRadius="10px"
            >
                <Icon as={MdOutlineMoreHoriz} w="24px" h="24px" />
            </MenuButton>
            <MenuList>{children}</MenuList>
        </Menu>
    );
}
